const Urun = resolve => {
    require.ensure(['../views/apps/urun/Urun'], () => {
        resolve(require('../views/apps/urun/Urun'))
    })
};
const UrunDetay = resolve => {
    require.ensure(['../views/apps/urun/UrunDetay'], () => {
        resolve(require('../views/apps/urun/UrunDetay'))
    })
};

const UrunTanimlama = resolve => {
    require.ensure(['../views/apps/urun/UrunTanimla'], () => {
        resolve(require('../views/apps/urun/UrunTanimla'))
    })
};
const UrunListesi = resolve => {
    require.ensure(['../views/apps/urun/UrunListesi'], () => {
        resolve(require('../views/apps/urun/UrunListesi'))
    })
};
const UrunDuzenle = resolve => {
    require.ensure(['../views/apps/urun/UrunDuzenle'], () => {
        resolve(require('../views/apps/urun/UrunDuzenle'))
    })
};
const Kategori = resolve => {
    require.ensure(['../views/apps/urun/kategori/kategori'], () => {
        resolve(require('../views/apps/urun/kategori/kategori'))
    })
};
const KategoriTanimlama = resolve => {
    require.ensure(['../views/apps/urun/kategori/KategoriTanimlama'], () => {
        resolve(require('../views/apps/urun/kategori/KategoriTanimlama'))
    })
};
const KategoriListe = resolve => {
    require.ensure(['../views/apps/urun/kategori/KategoriListe'], () => {
        resolve(require('../views/apps/urun/kategori/KategoriListe'))
    })
};
const KategoriDuzenle = resolve => {
    require.ensure(['../views/apps/urun/kategori/KategoriDuzenle'], () => {
        resolve(require('../views/apps/urun/kategori/KategoriDuzenle'))
    })
};

const Opsiyon = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/Opsiyon'], () => {
        resolve(require('../views/apps/urun/opsiyon/Opsiyon'))
    })
};
const OpsiyonIslem = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/OpsiyonIslem'], () => {
        resolve(require('../views/apps/urun/opsiyon/OpsiyonIslem'))
    })
};
const OpsiyonTanimlama = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/OpsiyonTanimla'], () => {
        resolve(require('../views/apps/urun/opsiyon/OpsiyonTanimla'))
    })
};
const OpsiyonListesi = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/OpsiyonListesi'], () => {
        resolve(require('../views/apps/urun/opsiyon/OpsiyonListesi'))
    })
};
const OpsiyonDuzenle = resolve => {
    require.ensure(['../views/apps/urun/opsiyon/OpsiyonDuzenle'], () => {
        resolve(require('../views/apps/urun/opsiyon/OpsiyonDuzenle'))
    })
};

const Malzeme = resolve => {
    require.ensure(['../views/apps/urun/malzeme/Malzeme'], () => {
        resolve(require('../views/apps/urun/malzeme/Malzeme'))
    })
};
const MalzemeIslem = resolve => {
    require.ensure(['../views/apps/urun/malzeme/MalzemeIslem'], () => {
        resolve(require('../views/apps/urun/malzeme/MalzemeIslem'))
    })
};
const MalzemeTanimlama = resolve => {
    require.ensure(['../views/apps/urun/malzeme/MalzemeTanimla'], () => {
        resolve(require('../views/apps/urun/malzeme/MalzemeTanimla'))
    })
};
const MalzemeListesi = resolve => {
    require.ensure(['../views/apps/urun/malzeme/MalzemeListesi'], () => {
        resolve(require('../views/apps/urun/malzeme/MalzemeListesi'))
    })
};
const MalzemeDuzenle = resolve => {
    require.ensure(['../views/apps/urun/malzeme/MalzemeDuzenle'], () => {
        resolve(require('../views/apps/urun/malzeme/MalzemeDuzenle'))
    })
};

import Vue from 'vue'
Vue.component('UrunDetay', UrunDetay);
Vue.component('UrunTanimla', UrunTanimlama);
Vue.component('UrunListesi', UrunListesi);
Vue.component('UrunDuzenle', UrunDuzenle);
Vue.component('KategoriTanimla', KategoriTanimlama);
Vue.component('KategoriListesi', KategoriListe);
Vue.component('KategoriDuzenle', KategoriDuzenle);
Vue.component('OpsiyonTanimla', OpsiyonTanimlama);
Vue.component('Opsiyonislem', OpsiyonIslem);
Vue.component('OpsiyonListesi', OpsiyonListesi);
Vue.component('OpsiyonDuzenle', OpsiyonDuzenle);
Vue.component('MalzemeTanimla', MalzemeTanimlama);
Vue.component('Malzemeislem', MalzemeIslem);
Vue.component('MalzemeListesi', MalzemeListesi);
Vue.component('MalzemeDuzenle', MalzemeDuzenle);

import layouts from '../layout'

export default {
    path: '/urun',
    name: 'urun',
    component: Urun,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: '/detay',
            name: 'urundetay',
            component: UrunDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
